import { useParams, useHistory } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import { useReactOidc } from "@axa-fr/react-oidc-context"
import { IntlContext } from "react-intl"

import Notification from "@views/common/Notification"
import { verifyEmailPhone } from "@services/PersonService"

const VerifyEmailPhone = () => {
    const { id } = useParams()
    const history = useHistory()
    const { oidcUser, login } = useReactOidc()
    const intlContext = useContext(IntlContext)

    const headers = {
        Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
        "Accept-Language": intlContext.locale
    }

    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)

    useEffect(() => {
        login()
        if (id) {
            verifyEmailPhone(headers, id)
                .then((res) => {
                    if (res?.status === 200) {
                        setSuccess(res?.data)
                        setTimeout(() => {
                            history.push("/profile")
                        }, 2000)
                    }
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {
                    setError(null)
                    setSuccess(null)
                })
        }
    }, [id])

    return (
        <>
            {error && <Notification data={{ error }} />}
            {success && <Notification data={{ success }} />}
        </>
    )
}
export default VerifyEmailPhone
